export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  modal: () => import("/app/layouts/modal.vue").then(m => m.default || m),
  "only-header": () => import("/app/layouts/only-header.vue").then(m => m.default || m)
}